import React, { useContext, useEffect, useState } from 'react';
import { AuthContext } from '../../contextStore/AuthContext';
import { useIsAdmin } from '../../utils/useIsAdmin';
import {
  getSiteSettings,
  refreshSiteSettings,
} from '../../firebase/siteSettings';
import { auth } from '../../firebase/auth';

const MAINTENANCE_POLL_MS = 60000;

function MaintenanceGate({ children }) {
  const { user, authLoading } = useContext(AuthContext);
  const isAdmin = useIsAdmin();
  const [maintenance, setMaintenance] = useState(
    () => getSiteSettings().maintenance_mode === true
  );
  const [showLogin, setShowLogin] = useState(false);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    let cancelled = false;
    const sync = () =>
      refreshSiteSettings()
        .then((s) => {
          if (!cancelled) setMaintenance(s.maintenance_mode === true);
        })
        .catch(() => {});
    sync();
    const timer = setInterval(sync, MAINTENANCE_POLL_MS);
    return () => {
      cancelled = true;
      clearInterval(timer);
    };
  }, []);

  const handleAdminLogin = async (e) => {
    e.preventDefault();
    if (!email.trim() || !password) {
      setError('Informe e-mail e senha.');
      return;
    }
    setBusy(true);
    setError('');
    try {
      await auth.signInWithEmailAndPassword(email.trim(), password);
      setEmail('');
      setPassword('');
      setShowLogin(false);
    } catch (err) {
      setError(err.message || 'Falha ao autenticar.');
    } finally {
      setBusy(false);
    }
  };

  if (authLoading || !maintenance || isAdmin) {
    return children;
  }

  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 99999,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#27173b',
        color: '#fff',
        padding: 24,
        textAlign: 'center',
      }}
    >
      <div style={{ fontWeight: 800, fontSize: 34, letterSpacing: 1 }}>
        SeBusca
      </div>
      <h1
        style={{
          margin: '16px 0 8px',
          fontSize: 24,
          fontWeight: 700,
          color: '#fff',
        }}
      >
        Estamos em manutenção
      </h1>
      <p
        style={{
          color: '#c4b5fd',
          maxWidth: 420,
          fontSize: 15,
          lineHeight: 1.6,
        }}
      >
        Estamos realizando melhorias para deixar tudo ainda melhor. Volte em
        instantes!
      </p>

      {!user && !showLogin && (
        <button
          type="button"
          onClick={() => setShowLogin(true)}
          style={{
            marginTop: 20,
            background: 'transparent',
            border: '1px solid #8b5cf6',
            color: '#e9d5ff',
            padding: '10px 20px',
            borderRadius: 8,
            fontSize: 14,
            cursor: 'pointer',
          }}
        >
          Acesso do administrador
        </button>
      )}

      {user && (
        <p style={{ marginTop: 12, fontSize: 13, color: '#a5b4fc' }}>
          Sua conta não possui acesso durante a manutenção.
        </p>
      )}

      {showLogin && (
        <form
          onSubmit={handleAdminLogin}
          style={{
            marginTop: 20,
            display: 'flex',
            flexDirection: 'column',
            gap: 10,
            width: '100%',
            maxWidth: 320,
          }}
        >
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="E-mail"
            style={{
              padding: '12px 14px',
              borderRadius: 8,
              border: 'none',
              fontSize: 14,
            }}
          />
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Senha"
            style={{
              padding: '12px 14px',
              borderRadius: 8,
              border: 'none',
              fontSize: 14,
            }}
          />
          {error && (
            <span style={{ color: '#fca5a5', fontSize: 13 }}>{error}</span>
          )}
          <button
            type="submit"
            disabled={busy}
            style={{
              padding: '12px 14px',
              borderRadius: 8,
              border: 'none',
              background: '#8b5cf6',
              color: '#fff',
              fontSize: 14,
              fontWeight: 700,
              cursor: busy ? 'default' : 'pointer',
              opacity: busy ? 0.7 : 1,
            }}
          >
            {busy ? 'Entrando...' : 'Entrar'}
          </button>
        </form>
      )}
    </div>
  );
}

export default MaintenanceGate;
